import { Injectable } from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";
import { Breadcrumb } from "src/app/shared/breadcrumb/breadcrumb.component";

@Injectable({
  providedIn: "root",
})
export class BreadcrumbService {
  breadcrumbs = new BehaviorSubject<Breadcrumb[]>([]);
  showEmailAndPrint = new BehaviorSubject<any>(undefined);
  showRefresh = new BehaviorSubject<boolean>(false);
  private refreshButtonClickSource = new Subject<void>();
  refreshButtonClick$ = this.refreshButtonClickSource.asObservable();

  showGraphFilterButton = new BehaviorSubject<boolean>(false);
  private graphFilterButtonClickSource = new Subject<void>();
  graphFilterButtonClickSource$ =
    this.graphFilterButtonClickSource.asObservable();

  showChartViewSettingButton = new BehaviorSubject<boolean>(false);
  private chartViewSettingButtonClickSource = new Subject<void>();
  chartViewSettingButtonClickSource$ =
    this.chartViewSettingButtonClickSource.asObservable();

  // Generic list/card view toggle for pages that render their data two ways.
  // The page owns the mode and pushes the icon and tooltip it wants shown, so
  // the header stays unaware of what is being toggled.
  showViewToggleButton = new BehaviorSubject<boolean>(false);
  viewToggleIcon = new BehaviorSubject<string>("grid-outline");
  viewToggleTitle = new BehaviorSubject<string>("Card View");
  private viewToggleButtonClickSource = new Subject<void>();
  viewToggleButtonClick$ = this.viewToggleButtonClickSource.asObservable();

  showManageHelpButton = new BehaviorSubject<boolean>(false);

  constructor() {}

  setBreadcrumbTitle(title: string, maxLength: number) {
    if (title.length <= maxLength) return title;
    return `${title.slice(0, maxLength).trim()}...`;
  }

  // Method to trigger button click
  triggerRefreshButtonClick() {
    this.refreshButtonClickSource.next();
  }

  triggerGraphFilterButtonClick() {
    this.graphFilterButtonClickSource.next();
  }

  triggerChartViewSettingButtonClick() {
    this.chartViewSettingButtonClickSource.next();
  }

  triggerViewToggleButtonClick() {
    this.viewToggleButtonClickSource.next();
  }
}
